// usePaymentProcess.js
import { useEffect, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
    initiateEasebuzzPaymentThunk,
    handleEasebuzzResponse,
    clearError,
} from "../features/payment/paymentSlice";
import { openEasebuzzPaymentModal } from "./easebuzzServiceNew";

// import {
//     DoWalletTopUp,
//     clearWalletError,
// } from '../features/wallet/walletSlice';

export const usePaymentProcess = ({ SetErrorMessage, setpaymentHookStatus, SetwalletpaymentStatus }) => {
    const dispatch = useDispatch();
    const { walletpaymentStatus, walletpaymentData } = useSelector((state) => state.wallet);
    const { paymentInitiated, paymentData } = useSelector((state) => state.payment);
    // open Easebuzz modal when payment initiated
    useEffect(() => {
        if (paymentInitiated && paymentData?.accessKey) {
            try {
                openEasebuzzPaymentModal(paymentData.enviroment, paymentData.accessKey, paymentData.paymentDetails, (response) => {
                    
                    dispatch(handleEasebuzzResponse(response));
                    if (response.status === 'success') {
                        //if (paymentData.paymentDetails?.udf5 === 42) {
                            SetErrorMessage('success')
                            setpaymentHookStatus('success')
                            SetwalletpaymentStatus(true)
                        //} 
                        // else {
                        //     const WalletopUp = {
                        //         "customer_id": paymentData.paymentDetails?.udf4,
                        //         "currency": paymentData.paymentDetails?.udf6,
                        //         "amount": paymentData.paymentDetails?.amount,
                        //         "PaymentMode": response.card_type + '-Web-B2B',
                        //         "ReferenceNo": response.easepayid,
                        //         "Notes": 'Wallet Recharge - ' + response.easepayid
                        //     }

                        //     SetErrorMessage(response.status)
                        //     setpaymentHookStatus(response.status)
                        //     dispatch(clearWalletError());
                        //     dispatch(DoWalletTopUp({ WalletopUp })).unwrap();
                        // }


                        // dispatch(verifyEasebuzzPayment({
                        //   txn_id: response.txnid,
                        //   amount: formData.amount,
                        //   email: formData.email
                        // }));
                    } else {
                        SetErrorMessage(response.status)
                        setpaymentHookStatus('paymentfailed')
                    }
                });
            } catch (error) {
                SetErrorMessage("Failed to proceed payment");
                setpaymentHookStatus("paymentfailed");
                console.error("Failed to open payment modal:", error);
            }
        }
    }, [paymentInitiated, paymentData, dispatch, SetErrorMessage, setpaymentHookStatus, SetwalletpaymentStatus]);

    useEffect(() => {
        if (walletpaymentStatus === true && walletpaymentData?.status?.success === true) {
            SetwalletpaymentStatus(walletpaymentData?.status?.success)
        }
    }, [walletpaymentStatus, walletpaymentData]);
    // 🔑 handleProceed now accepts dynamic paymentDetails
    const handleProceed = useCallback(
        (paymentDetails, e) => {
            if (e) e.preventDefault();
            if (!paymentDetails) {
                SetErrorMessage("Missing payment details");
                return;
            }
            dispatch(clearError());
            dispatch(initiateEasebuzzPaymentThunk(paymentDetails));
        },
        [dispatch, SetErrorMessage]
    );

    return { handleProceed };
};


// import { useEffect, useCallback } from "react";
// import { useDispatch, useSelector } from "react-redux";
// import {
//     initiateEasebuzzPaymentThunk,
//     handleEasebuzzResponse,
//     clearError,
// } from "../features/payment/paymentSlice";
// import { openEasebuzzPaymentModal } from "./easebuzzServiceNew";

// export const usePaymentProcess = ({ paymentDetails, SetErrorMessage, setpaymentHookStatus }) => {
//     const dispatch = useDispatch();
//     const { paymentInitiated, paymentData } = useSelector((state) => state.payment);

//     // open Easebuzz modal when payment initiated
//     useEffect(() => {
//         if (paymentInitiated && paymentData?.accessKey) {
//             try {
//                 openEasebuzzPaymentModal(paymentData.accessKey, paymentDetails, (response) => {
//                     console.log(response);

//                     dispatch(handleEasebuzzResponse(response));

//                     if (response.status !== "success") {
//                         SetErrorMessage(response.status);
//                         setpaymentHookStatus("paymentfailed");
//                     }
//                 });
//             } catch (error) {
//                 SetErrorMessage("Failed to proceed payment");
//                 setpaymentHookStatus("paymentfailed");
//                 console.error("Failed to open payment modal:", error);
//             }
//         }
//     }, [paymentInitiated, paymentData, dispatch, paymentDetails, SetErrorMessage, setpaymentHookStatus]);

//     // 🔑 Expose handleProceed function
//     const handleProceed = useCallback(
//         (e) => {
//             if (e) e.preventDefault();
//             dispatch(clearError());
//             dispatch(initiateEasebuzzPaymentThunk(paymentDetails));
//         },
//         [dispatch, paymentDetails]
//     );

//     return { handleProceed };
// };
